import Papa from 'papaparse';

class LocationsManager {
  constructor() {
    this.data = [];
  }

  loadCsv(onComplete) {
    this.data = [];
    Papa.parse(
      `${
        window.location.protocol + window.location.host
      }/street-gallery-bts/assets/locations.csv`,
      {
        download: true,
        worker: true,
        header: true,
        step: (results) => {
          const pano = this.processUrl(results.data.url);
          if (pano) {
            results.data.panoid = pano.id;
            results.data.city = results.data.city.trim();
            results.data.img =
              './street-gallery-bts/assets/thumbnails/' + pano.id + '.jpg';
            results.data.heading = pano.heading;
            results.data.pitch = pano.pitch;
            this.data.push(results.data);
          }
        },
        complete: () => {
          this.data.sort((a, b) => {
            const textA = a.city.toUpperCase();
            const textB = b.city.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          });

          onComplete();
        },
      },
    );
  }

  getCities() {
    const tmpResult = [];
    const result = [];
    this.data.forEach((item) => {
      if (item.city && !tmpResult.includes(item.city)) {
        tmpResult.push(item.city);

        // we modify the result for app case
        const modififed = { ...item };
        modififed.title = modififed.city;

        // check if we have an image on thumbs
        // if (thumbs['thumbs'][item.city.toLowerCase()]) {
        // modififed.img =
        // 'street-gallery-bts/assets/thumbs/' + thumbs['thumbs'][item.city.toLowerCase()];
        // }

        result.push(modififed);
      }
    });
    return result;
  }

  getByCity(city) {
    const result = [];
    this.data.forEach((item) => {
      if (item.city && item.city.toLowerCase() === city.toLowerCase()) {
        result.push(item);
      }
    });

    result.sort((a, b) => {
      const textA = a.name.toUpperCase();
      const textB = b.name.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    return result;
  }

  getByPanoId(panoId) {
    let result = null;
    this.data.forEach((item) => {
      if (item.panoid === panoId) {
        result = item;
      }
    });
    return result;
  }

  processUrl(u) {
    const url = decodeURIComponent(u);
    const match = url.match('^https://.*!1s(.*)!2e.*$');
    const id = match && match[1];
    const pov = url.match(/,([0-9.]+)y,([0-9.]+)h,([0-9.]+)t/);
    const result = {};
    if (id) {
      result.id = id;

      if (pov) {
        const heading = Number(pov[2]);
        const pitch = -90 + Number(pov[3]);
        result.heading = heading;
        result.pitch = pitch;
      }

      return result;
    }
    return null;
  }
}
export default LocationsManager;
